import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireDatabase } from "@angular/fire/database";
import { Router } from '@angular/router';
import { UsuarioService } from '../../../services/usuario.service';

import * as firebase from 'firebase';

@Component({
  selector: 'app-alterar-status-pedido-demanda-dialog',
  templateUrl: './alterar-status-pedido-demanda-dialog.html',
  styleUrls: ['./alterar-status-pedido-demanda-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class AlterarStatusPedidoDemandaDialog implements OnInit {
  uid;

  pedidosConfirmados: any = [];
  pedidosEmSeparacao: any = [];
  pedidosEmRota: any = [];
  datePrevisaoEntrega: Date = new Date();
  minDate: Date = new Date();

  sStatusConfirmados = 'Em separação';
  sStatusEmSeparacao = 'Em rota';
  sStatusEmRota = 'Entregue';

  sAuxConfirmados = '';
  sAuxEmSeparacao = '';
  sAuxEmRota = '';

  sErrosAlteracao = [];


  constructor(
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<AlterarStatusPedidoDemandaDialog>,
    private spinner: NgxSpinnerService,
    private db: AngularFireDatabase,
    private router: Router,
    private usuarioService: UsuarioService,
    @Inject(MAT_DIALOG_DATA) public data: { pedidos: any }) {
    this.uid = localStorage.getItem('uid');
  }

  ngOnInit(): void {
    this.pedidosConfirmados = [];
    this.pedidosEmSeparacao = [];
    this.pedidosEmRota = [];

    this.sAuxConfirmados = '';
    this.sAuxEmSeparacao = '';
    this.sAuxEmRota = '';
    const pedidos = this.data.pedidos;

    for (let i = 0; i < pedidos.length; i++) {
      switch (pedidos[i].Status) {
        case 'Confirmado':
          this.pedidosConfirmados.push({ ID: pedidos[i].ID, TimestampPrevisaoRota: pedidos[i].TimestampPrevisaoRota });

          this.sAuxConfirmados = this.sAuxConfirmados + pedidos[i].ID + '; ';
          break;

        case 'Em separação':
          this.pedidosEmSeparacao.push({ ID: pedidos[i].ID });
          this.sAuxEmSeparacao = this.sAuxEmSeparacao + pedidos[i].ID + '; ';
          break;

        case 'Em rota':
          this.pedidosEmRota.push({ ID: pedidos[i].ID });
          this.sAuxEmRota = this.sAuxEmRota + pedidos[i].ID + '; ';
          break;
      }
    }
  }

  confirmarAlteracaoStatus() {
    if (this.pedidosConfirmados.length > 0 || this.pedidosEmSeparacao.length > 0 || this.pedidosEmRota.length > 0) {
      this.spinner.show('default');
      this.toastr.warning('Um momento enquanto a alteração em demanda é aplicada...', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      this.sErrosAlteracao = [];

      setTimeout(() => {
        //Alterar os pedidos com status "Confirmado"
        if (this.pedidosConfirmados.length > 0) {

          Promise.all(this.pedidosConfirmados.map(async (dado) => {
            this.db.object('Clientes/' + this.uid + '/Pedidos/' + dado.ID).query.ref.transaction(dadosPedido => {
              if (dadosPedido.Status === 'Confirmado') {

                const auxDate = new Date(this.datePrevisaoEntrega);

                if (this.sStatusConfirmados === 'Em separação') {
                  dadosPedido.Status = 'Em separação';

                  if (!dadosPedido.TimestampPrevisaoRota) {
                    dadosPedido.TimestampPrevisaoRota = auxDate.getTime();
                  }
                  dadosPedido.TimestampSeparacao = firebase.default.database.ServerValue.TIMESTAMP;
                  return dadosPedido;
                } else
                  if (this.sStatusConfirmados === 'Em rota') {
                    if (dadosPedido.Status === 'Confirmado' || dadosPedido.Status === 'Em separação') {
                      dadosPedido.Status = 'Em rota';
                      dadosPedido.TimestampRota = firebase.default.database.ServerValue.TIMESTAMP;

                      //Trata o pulo de status de pedido
                      dadosPedido.TimestampPrevisaoRota = dadosPedido.TimestampPrevisaoRota ? dadosPedido.TimestampPrevisaoRota : auxDate.getTime();
                      dadosPedido.TimestampSeparacao = dadosPedido.TimestampSeparacao ? dadosPedido.TimestampSeparacao : firebase.default.database.ServerValue.TIMESTAMP;

                      return dadosPedido;
                    } else {
                      this.sErrosAlteracao.push(dado.ID);
                      return dadosPedido;
                    }

                  } else
                    if (this.sStatusConfirmados === 'Entregue') {
                      if (dadosPedido.Status === 'Confirmado' || dadosPedido.Status === 'Em separação' || dadosPedido.Status === 'Em rota') {
                        dadosPedido.Status = 'Entregue';
                        dadosPedido.TimestampEntregue = firebase.default.database.ServerValue.TIMESTAMP;

                        //Trata o pulo de status de pedido
                        dadosPedido.TimestampPrevisaoRota = dadosPedido.TimestampPrevisaoRota ? dadosPedido.TimestampPrevisaoRota : auxDate.getTime();
                        dadosPedido.TimestampRota = dadosPedido.TimestampRota ? dadosPedido.TimestampRota : firebase.default.database.ServerValue.TIMESTAMP;
                        dadosPedido.TimestampSeparacao = dadosPedido.TimestampSeparacao ? dadosPedido.TimestampSeparacao : firebase.default.database.ServerValue.TIMESTAMP;

                        return dadosPedido;
                      } else {
                        this.sErrosAlteracao.push(dado.ID);
                        return dadosPedido;
                      }
                    }
              } else {
                this.sErrosAlteracao.push(dado.ID);
                return dadosPedido;
              }
            }).catch(err => {
              this.sErrosAlteracao.push(dado.ID);
              this.finalizarProcesso(false, err);
            });
          })).finally(() => {

          }).catch(err => {
            this.finalizarProcesso(false, err);
            console.log(err);
            console.log(this.sErrosAlteracao);
          });
        }

        //Alterar os pedidos com status "Em separação"
        if (this.pedidosEmSeparacao.length > 0) {

          Promise.all(this.pedidosEmSeparacao.map(async (dado) => {
            this.db.object('Clientes/' + this.uid + '/Pedidos/' + dado.ID).query.ref.transaction(dadosPedido => {
              if (dadosPedido.Status === 'Em separação') {

                if (this.sStatusEmSeparacao === 'Em rota') {
                  if (dadosPedido.Status === 'Em separação') {
                    dadosPedido.Status = 'Em rota';
                    dadosPedido.TimestampRota = firebase.default.database.ServerValue.TIMESTAMP;

                    //Trata o pulo de status de pedido
                    dadosPedido.TimestampSeparacao = dadosPedido.TimestampSeparacao ? dadosPedido.TimestampSeparacao : firebase.default.database.ServerValue.TIMESTAMP;

                    return dadosPedido;
                  } else {
                    this.sErrosAlteracao.push(dado.ID);
                    return dadosPedido;
                  }
                } else
                  if (this.sStatusEmSeparacao === 'Entregue') {
                    if (dadosPedido.Status === 'Em separação') {
                      dadosPedido.Status = 'Entregue';
                      dadosPedido.TimestampEntregue = firebase.default.database.ServerValue.TIMESTAMP;

                      //Trata o pulo de status de pedido
                      dadosPedido.TimestampRota = dadosPedido.TimestampRota ? dadosPedido.TimestampRota : firebase.default.database.ServerValue.TIMESTAMP;
                      dadosPedido.TimestampSeparacao = dadosPedido.TimestampSeparacao ? dadosPedido.TimestampSeparacao : firebase.default.database.ServerValue.TIMESTAMP;

                      return dadosPedido;
                    } else {
                      this.sErrosAlteracao.push(dado.ID);
                      return dadosPedido;
                    }
                  }
              }
              return dadosPedido;
            }).catch(err => {
              this.sErrosAlteracao.push(dado.ID);
              this.finalizarProcesso(false, err);
            });
          })).finally(() => {

          }).catch(err => {
            this.finalizarProcesso(false, err);

            console.log(err);
            console.log(this.sErrosAlteracao);
          });
        }

        //Alterar os pedidos com status "Em rota"
        if (this.pedidosEmRota.length > 0) {

          Promise.all(this.pedidosEmRota.map(async (dado) => {
            this.db.object('Clientes/' + this.uid + '/Pedidos/' + dado.ID).query.ref.transaction(dadosPedido => {

              if (this.sStatusEmRota === 'Entregue') {
                if (dadosPedido.Status === 'Em rota') {
                  dadosPedido.Status = 'Entregue';
                  dadosPedido.TimestampEntregue = firebase.default.database.ServerValue.TIMESTAMP;
                  return dadosPedido;
                } else {
                  this.sErrosAlteracao.push(dado.ID);
                  return dadosPedido;
                }
              }
              return dadosPedido;
            }).catch(err => {
              this.sErrosAlteracao.push(dado.ID);
              this.finalizarProcesso(false, err);
            });
          })).finally(() => {

          }).catch(err => {

            this.finalizarProcesso(false, err);
            console.log(err);
            console.log(this.sErrosAlteracao);
          });
        }

        this.finalizarProcesso(true, false);
      }, 500);
    } else
      this.toastr.error("Não há pedidos para realizar a alteração de status!", 'Erro');
  }

  finalizarProcesso(b, err) {
    //Finaliza o processo
    setTimeout(() => {
      const map = {
        Confirmados: this.pedidosConfirmados,
        StatusConfirmados: this.sStatusConfirmados,
        EmSeparacao: this.pedidosEmSeparacao,
        StatusEmSeparacao: this.sStatusEmSeparacao,
        EmRota: this.pedidosEmRota,
        StatusEmRota: this.sStatusEmRota,
        Erros: this.sErrosAlteracao,
        Err: err
      }

      this.usuarioService.setLog("Alteração de status em demanda", map, this.uid);

      this.dialogRef.close();
      this.toastr.clear();
      if (this.sErrosAlteracao.length === 0 && b) {
        this.toastr.success('Todos os pedidos foram alterados com sucesso!', 'Status', { progressBar: false, positionClass: 'toast-top-center', });
      } else {
        alert('Houve um erro na alteração de status de demanda no(s) pedido(s): \n\n' + this.sErrosAlteracao + '. \n\n\nANOTE ESTE DADO E CONFIRA OS PEDIDOS');
      }
      this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
        this.router.navigate(["/pages/consultar-pedidos"]));

      setTimeout(() => this.spinner.hide('default'), 300);
    }, 3000)
  }

  cancelar() {
    this.dialogRef.close();
  }

}
